import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import RequestAccessModal from "./RequestAccessModal";

const FEATURE_LABEL = {
  reports: "Reports",
  marketing: "Marketing",
  po: "Purchase Orders",
};

// Vendor Feature Lock (ADO #1597) — rendered by FeatureGuard in place of a locked
// route. Inherits Layout from PrivateRoute, same convention as PageNotAccess.
const FeatureLocked = ({ feature }) => {
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState(false);
  const label = FEATURE_LABEL[feature] || feature;
  return (
    <div className="feature-locked">
      <h2>{t(`${label} is a premium feature`)}</h2>
      <p>
        {t(
          "This section is available on a paid subscription. Contact our support team to upgrade and unlock access."
        )}
      </p>
      <button
        type="button"
        className="primary-btn"
        onClick={() => setModalVisible(true)}
      >
        {t("Contact Support to Subscribe")}
      </button>
      <RequestAccessModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        feature={feature}
      />
    </div>
  );
};

export default FeatureLocked;
